import { Injectable } from '@angular/core';
import { ArticleType } from '../entities/article-type';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment.development';
import { catchError, Observable, of } from 'rxjs';

interface ApiResponse {
  status: string;
  data: ArticleType[];
}

@Injectable({
  providedIn: 'root'
})
export class ArticleTypeService {

  constructor(private http: HttpClient) { }

  private apiServicesUrl = environment.cfgApiBaseUrl;
  private articleTypeServiceUrl = this.apiServicesUrl + '/article-type';

  getArticleTypes(): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(this.articleTypeServiceUrl)
    .pipe(
      catchError(this.handleError<ApiResponse>('getArticleType'))
    );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
  
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
  
      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);
  
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
